// removed by extract-text-webpack-plugin
module.exports = {"subscribe":"subscribe__3RiHU","title":"title__2znj0","subtitle":"subtitle__33m7o","innerContainer":"innerContainer__2le6d","inputsContainer":"inputsContainer__26WEI","customMargin":"customMargin__1ykAb","button":"button__1JDMv","arrow":"arrow__1BSJm","spinner":"spinner__vn58t","status":"status__2XTVg"};


//////////////////
// WEBPACK FOOTER
// ./components/subscribe/styles.scss
// module id = pdcr
// module chunks = 1